import { createFileRoute } from "@tanstack/react-router";

import { LiveRiskMatrixCanvas } from "@/components/canvas/live-risk-matrix-canvas";

export const Route = createFileRoute("/$workspace/risk")({
  head: () => ({ meta: [{ title: "Risk Matrix — Dravian Horizon" }] }),
  component: RiskPage,
});

function RiskPage() {
  const { workspace } = Route.useParams();
  return <LiveRiskMatrixCanvas workspaceId={workspace} />;
}
